import { SpaceIOService, UserService } from "auth-utils";
import { ACCOUNTWS_BASE_URL, AUTH_URL } from "./config";

const bootstrap = () => {
    const spaceIOService = new SpaceIOService({
        newAuthTokenBufferTimeInSeconds: 30,
        accountWsUrl: ACCOUNTWS_BASE_URL,
        loginUrl: AUTH_URL,
    });
    const userService = new UserService({ spaceIOService });

    return {
        spaceIOService,
        userService,
    };
};

export default bootstrap;
